import DropdownKioskStatus from './DropdownKioskStatus'
export default DropdownKioskStatus